export const API_BASE_URL = 'https://api-pavillion.karimcgvisuals.ke';
